import type { NextPlanActionType } from './actions';

export default (state = {}, action: NextPlanActionType) => {
  switch (action.type) {
    case 'SET_NEXT_PLAN':
      return action.payload.nextPlan;
    default:
      return state;
  }
};
